module.exports = __webpack_public_path__ + "static/img/super-chat-pass.55875e6c.png";